//import { useThankyouModal } from '@ui/pages/thank-you/hooks/use-thankyou-modal.hook.ts'
import { BoxComponent, BoxSelectorComponent } from '@ui/components/box-selector'
import { isDeviceMobile } from '@utils/mobile'
import { useMemo } from 'react'
import { useThankyouModal } from '../hooks/use-thankyou-modal.hook'

export const UploadDocuments: React.FC<{
	onMobileUploadSelected: () => void
}> = (props) => {
	const modal = useThankyouModal()
	const isMobile = useMemo(() => isDeviceMobile(), [])

	return (
		<BoxSelectorComponent
			title={'Carica subito'}
			desktopDescription={'Carica subito i tuoi documenti.'}
			selected
		>
			{!isMobile && (
				<BoxComponent
					desktopTitle={'Allega i documenti'}
					icon={'Allega.svg'}
					action={modal.actions.startLocalModal}
				/>
			)}

			<BoxComponent
				desktopTitle={'Fotografa i documenti'}
				icon={'Fotocamera.svg'}
				action={() => {
					if (!isMobile) {
						modal.actions.startPollingModal()
					} else {
						props.onMobileUploadSelected()
					}
				}}
			/>
		</BoxSelectorComponent>
	)
}
